export const state = {
  // NOTE: Company Setting Data
  dashboardData: [],
  userSettingData: [],
  rooms: [],
  setupState: {
    calendar: 'yet',
    roomResource: 'yet',
    schedulingCommon: 'yet',
    personal: 'yet',
    chat: 'yet',
  },
  dayPlanNg: '',
  dayPlanOk: '',
  timePlanNg: '',
  timePlanOk: '',
  sharingAdjustmentNg: '',
  sharingAdjustmentOk: '',
  defaultLang: '',
  workHourSetting: {
    sunday: {
      isWorkday: false,
      workHour: {start: '', end: ''},
      breakTime: [{start: '', end: ''}]
    },
    monday: {
      isWorkday: false,
      workHour: {start: '', end: ''},
      breakTime: [{start: '', end: ''}]
    },
    tuesday: {
      isWorkday: false,
      workHour: {start: '', end: ''},
      breakTime: [{start: '', end: ''}]
    },
    wednesday: {
      isWorkday: false,
      workHour: {start: '', end: ''},
      breakTime: [{start: '', end: ''}]
    },
    thursday: {
      isWorkday: false,
      workHour: {start: '', end: ''},
      breakTime: [{start: '', end: ''}]
    },
    friday: {
      isWorkday: false,
      workHour: {start: '', end: ''},
      breakTime: [{start: '', end: ''}]
    },
    saturday: {
      isWorkday: false,
      workHour: {start: '', end: ''},
      breakTime: [{start: '', end: ''}]
    }
  },
  // NOTE: User Personal Setting Data
  availableLocations: [],
  selectedLocation: '',
  userDayPlanNg: '',
  userDayPlanOk: '',
  userTimePlanNg: '',
  userTimePlanOk: '',
  userSharingAdjustmentNg: '',
  userSharingAdjustmentOk: '',
}
